import React from "react";
import { useSettings } from "../contexts/SettingsContext";
import { SettingsIcon } from "lucide-react";

const InterfaceSettings = () => {
  const {
    hideChatSidebar,
    setHideChatSidebar,
    darkMode,
    setDarkMode,
    notifications,
    setNotifications,
    hideChatMode,
    setHideChatMode,
    hideSearch,
    setHideSearch,
    hideExport,
    setHideExport,
    debugMode,
    setDebugMode,
  } = useSettings();

  const toggleClass =
    "w-9 h-5 bg-gray-500 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#334155] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#8b3dff]";

  return (
    <div className="mb-8 bg-[#1e293b] border-[#334155] rounded-lg shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-white mb-6 flex items-center">
        <SettingsIcon className="w-5 h-5 mr-2" />
        Interface Settings
      </h3>

      <div className="space-y-6">
        {/* Chat Sidebar */}
        {/* <div className="flex items-center justify-between p-4 border border-[#334155] rounded-lg">
          <div>
            <label className="text-sm font-medium text-white">
              Hide Chat Sidebar
            </label>
            <p className="text-xs text-[#64748b] mt-1">
              Show only the conversation area (full-width mode)
            </p>
            <div className="mt-2 text-xs text-[#8b3dff]">
              Current: {hideChatSidebar ? "🚫 Hidden" : "👁️ Visible"}
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={hideChatSidebar}
              onChange={(e) => setHideChatSidebar(e.target.checked)}
              className="sr-only peer"
            />
            <div className={toggleClass}></div>
          </label>
        </div> */}

        {/* Test Chat Button */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-white font-medium">Test the Settings</p>
            <p className="text-xs text-[#64748b] mt-1">
              Click to test how the sidebar setting works in chat
            </p>
          </div>
          <button
            onClick={() => (window.location.href = "/chat")}
            className="bg-[#8b3dff] text-white px-4 py-2 rounded-lg transition-colors flex items-center space-x-2"
          >
            <span>🧪</span>
            <span>Test Chat Interface</span>
          </button>
        </div>

        {/* Advanced Settings */}
        <div className="pt-4 border-t border-[#334155]">
          <h4 className="text-sm font-medium text-white mb-3">
            Advanced Settings
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Dark Mode (disabled toggle) */}
            <div className="flex items-center justify-between p-3 border border-[#334155] rounded opacity-70">
              <div>
                <label className="text-sm text-white">Dark Mode</label>
                <p className="text-xs text-[#64748b]">Toggle dark theme</p>
              </div>
              <label className="relative inline-flex items-center cursor-not-allowed pointer-events-none">
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={(e) => setDarkMode(e.target.checked)}
                  className="sr-only peer"
                />
                <div className={toggleClass}></div>
              </label>
            </div>

            {/* Other toggles */}
            {[
              {
                label: "Notifications",
                desc: "Enable notifications",
                value: notifications,
                setter: setNotifications,
              },
              {
                label: "Hide Chat Mode",
                desc: "Toggle hide chat mode",
                value: hideChatMode,
                setter: setHideChatMode,
              },
              {
                label: "Hide Export Button",
                desc: "Toggle hide export button",
                value: hideExport,
                setter: setHideExport,
              },
              {
                label: "Hide Search Button",
                desc: "Toggle hide search button",
                value: hideSearch,
                setter: setHideSearch,
              },
              {
                label: "Debug Mode",
                desc: "Enable developer debug logs and info panels",
                value: debugMode,
                setter: setDebugMode,
              },
            ].map(({ label, desc, value, setter }) => (
              <div
                key={label}
                className="flex items-center justify-between p-3 border border-[#334155] rounded"
              >
                <div>
                  <label className="text-sm text-white">{label}</label>
                  <p className="text-xs text-[#64748b]">{desc}</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => setter(e.target.checked)}
                    className="sr-only peer"
                  />
                  <div className={toggleClass}></div>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterfaceSettings;